module.exports = __webpack_public_path__ + "img/Artboard – 1 (7).a0cd37ef.png";